import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
export default {
  name: 'NiotaClassicDevicetypesPacketParserSingle',
  mixins: [formMixin],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    },
    hidePredefinedParserSelection: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      parserConfigInternal: {}
    };
  },
  computed: {
    formElement() {
      return this.$refs.form;
    }
  },
  watch: {
    parserConfig: {
      handler: function (val) {
        const clonedPropParserConfig = cloneDeep(val);
        this.parserConfigInternal = clonedPropParserConfig;
      },
      immediate: true
    }
  },
  methods: {
    onConfigChanged(config) {
      this.parserConfigInternal = config;
      this.emitChanges();
    },
    emitChanges() {
      const clonedConfig = cloneDeep(this.parserConfigInternal);
      this.$emit('config-updated', clonedConfig);
    },
    onTypeDefinitionsUpdated(newVariables) {
      this.parserConfigInternal = {
        ...this.parserConfigInternal,
        variables: newVariables
      };
      this.emitChanges();
    }
  }
};